/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
import React from 'react';

const BoxBorderBlue = (props) => {

    return (
        <div className="boxBorder">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 226.7 195.3" enableBackground="new 0 0 226.7 195.3" xmlSpace="preserve" preserveAspectRatio="none">
                <path className="boxBorder__path" id={props.id} fill="none" stroke="#7393B5" strokeWidth="5" strokeMiterlimit="10" d="M223.7,97.4v-89c0-3.2-3.6-5.9-8-5.9H10.4
	c-4.4,0-8,2.6-8,5.9v178.4c0,3.2,3.6,5.9,8,5.9h205.3c4.4,0,8-2.6,8-5.9V97.4z"/>
            </svg>
        </div>
    );
}

export default BoxBorderBlue;



// WEBPACK FOOTER //
// ./frontend/pages/LiveMarkets/BoxBorderBlue.jsx